;(function () {
  angular
    .module('contrast.permissions')
    .directive('hasAppPermissionDisable', function (permissions) {
      'ngInject'

      return {
        link: function (scope, element, attrs) {
          if (!_.isString(attrs.hasAppPermissionDisable)) {
            // eslint-disable-next-line no-throw-literal
            throw 'hasPermissionDisable value must be a string'
          }
          if (!_.isString(attrs.application)) {
            // eslint-disable-next-line no-throw-literal
            throw 'application value must be a string'
          }

          var value = attrs.hasAppPermissionDisable.trim()
          var application = attrs.application.trim()
          var permissionChecks = [],
            tempRoles = []

          if (value.indexOf(' || ') > -1) {
            tempRoles = value.split(' || ')
          } else {
            tempRoles.push(value)
          }

          angular.forEach(
            tempRoles,
            function (role) {
              var notPermissionFlag = role[0] === '!'
              if (notPermissionFlag) {
                role = role.slice(1).trim()
              }
              permissionChecks.push({
                role: role,
                notPermissionFlag: notPermissionFlag
              })
            },
            this
          )

          function toggleVisibilityBasedOnPermission() {
            var disabled = true
            angular.forEach(
              permissionChecks,
              function (permissionCheck) {
                var hasPermission = permissions.hasAppPermission(
                  application,
                  permissionCheck.role
                )
                if (
                  (hasPermission && !permissionCheck.notPermissionFlag) ||
                  (!hasPermission && permissionCheck.notPermissionFlag)
                ) {
                  disabled = false
                }
              },
              this
            )

            if (disabled) {
              element.attr('disabled', 'disabled')
            } else {
              element.removeAttr('disabled')
            }
          }

          toggleVisibilityBasedOnPermission()
          scope.$on('apppermissions:updated', toggleVisibilityBasedOnPermission)
        }
      }
    })
})()
